import groupBy from "lodash/groupBy";
import Parameter from "views/logic/parameters/Parameter";
import fetch from "logic/rest/FetchProvider";
import URLUtils from "util/URLUtils";
import Widget from "views/logic/widgets/Widget";
const deserializeWidget = (widget) => ({
  ...widget,
  config: Widget.fromJSON(widget).config
});
const fetchWidgetDetails = (widgets) => fetch("POST", URLUtils.qualifyUrl("/plugins/org.graylog.plugins.report/widgets/details"), widgets).then(
  (response) => {
    const parameters = groupBy(
      Object.values(response.parameters).flat().map((param) => Parameter.fromJSON(param)),
      "name"
    );
    return {
      widgets: Object.fromEntries(response.widgets.map((w) => [w.dashboard_widget_id, deserializeWidget(w)])),
      searchIds: response.search_ids,
      parameters
    };
  }
);
export default fetchWidgetDetails;
